import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip
} from '@material-ui/core'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import React, { useState } from 'react'

// The bare (i) → "how this page works" dialog — the exact idiom Parent
// Onboarding / Roster / Event Creatives use, so Revenue Goals reads as
// part of the same family. Sits next to the page's h5 title.
const GuideButton = ({ title, children }) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Tooltip title="How this page works">
        <IconButton size="small" onClick={() => setOpen(true)}>
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent style={{ paddingBottom: 24 }}>{children}</DialogContent>
      </Dialog>
    </>
  )
}

export default GuideButton
